<template>
  <!-- Sidebar -->
  <ul
    class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
    id="accordionSidebar"
  >
    <!-- Sidebar - Brand -->
    <a
      class="
        navbar-brand
        sidebar-brand
        d-flex
        align-items-center
        justify-content-center
      "
      href="/"
    >
      <!-- <div class="sidebar-brand-icon rotate-n-15">
          <i class="fas fa-laugh-wink"></i>
        </div> -->
      <!-- <div class="sidebar-brand-icon">
          <img class='rounded' src="/assets/img/logo.png"  style="width:45px;"/>
        </div> -->
      <div class="sidebar-brand-text mx-3">
        {{ appname }}
      </div>
    </a>

    <!-- Heading -->
    <div
      class="sidebar-heading"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'teacher'
      "
    >
      Багш
    </div>
    <!-- Nav Item - Dashboard -->
    <router-link to="/dashboard" class="nav-item">
      <a class="nav-link" href="">
        <i class="fas fa-fw fa-tachometer-alt"></i>
        <span>Dashboard</span>
      </a>
    </router-link>
    <!-- Nav Item - Pages Collapse Menu -->
    <router-link to="/mynews" class="nav-item">
      <a class="nav-link">
        <i class="fas fa-book-open"></i>
        <span>Мэдээ</span>
      </a>
    </router-link>
    <router-link to="/asuulga" class="nav-item">
      <a class="nav-link">
        <i class="fas fa-book-open"></i>
        <span>Санал асуулга</span>
      </a>
    </router-link>
    <router-link
      to="/hello"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        (userProfile.role == 'teacher' ||
          userProfile.role == 'sts' ||
          userProfile.role == 'admin')
      "
    >
      <a class="nav-link">
        <i class="fas fa-book-open"></i>
        <span>Миний хичээлүүд</span>
      </a>
    </router-link>

    <router-link
      to="/groups"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        (userProfile.role == 'teacher' ||
          userProfile.role == 'sts' ||
          userProfile.role == 'admin')
      "
    >
      <a class="nav-link">
        <i class="fas fa-users"></i>
        <span>Миний группууд</span>
      </a>
    </router-link>

    <!-- <router-link
      to="/managealllessons"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'manager'
      "
    >
      <a class="nav-link">
        <i class="fas fa-users"></i>
        <span>Xичээлүүд</span>
      </a>
    </router-link> -->

    <template v-if="schoolId != null">
      <router-link
        :to="{
          name: 'SDepartments',
          params: { schoolId: schoolId },
        }"
        class="nav-item"
        v-if="
          currentUser != null &&
          userProfile != null &&
          (userProfile.role == 'manager' || userProfile.role == 'admin')
        "
      >
        <a class="nav-link">
          <i class="fas fa-users"></i>
          <span>Ангиудын удирдлага</span>
        </a>
      </router-link>
      <router-link
        :to="{
          name: 'Dungiinhavtgai',
          params: { schoolId: schoolId },
        }"
        class="nav-item"
        v-if="
          currentUser != null &&
          userProfile != null &&
          (userProfile.role == 'manager' || userProfile.role == 'admin')
        "
      >
        <a class="nav-link">
          <i class="fas fa-users"></i>
          <span>Дүнгийн нэгтгэл</span>
        </a>
      </router-link>
    </template>

    <router-link
      to="/onlinerooms"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        (userProfile.role == 'teacher' ||
          userProfile.role == 'sts' ||
          userProfile.role == 'manager' ||
          userProfile.role == 'admin')
      "
    >
      <a class="nav-link">
        <i class="fas fa-users"></i>
        <span>Ангийн Онлайн өрөөнүүд</span>
      </a>
    </router-link>
    <router-link
      to="/songononlinerooms"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        (userProfile.role == 'teacher' ||
          userProfile.role == 'sts' ||
          userProfile.role == 'manager' ||
          userProfile.role == 'admin')
      "
    >
      <a class="nav-link">
        <i class="fas fa-users"></i>
        <span>Сонгон Онлайн өрөөнүүд</span>
      </a>
    </router-link>

    <router-link to="/mycalendar" class="nav-item">
      <a class="nav-link">
        <i class="fas fa-users"></i>
        <span>Xуваарь</span>
      </a>
    </router-link>

    <router-link
      to="/mydashboard"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        (userProfile.role == 'teacher' ||
          userProfile.role == 'sts' ||
          userProfile.role == 'admin')
      "
    >
      <a class="nav-link">
        <i class="fas fa-users"></i>
        <span>Charts</span>
      </a>
    </router-link>
    <router-link
      to="/curriculum"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        (userProfile.role == 'teacher' ||
          userProfile.role == 'sts' ||
          userProfile.role == 'admin')
      "
    >
      <a class="nav-link">
        <i class="fas fa-users"></i>
        <span>Сургалтын xөтөлбөр</span>
      </a>
    </router-link>
    <!-- <router-link to="/qalinks" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='teacher' || userProfile.role=='sts' || userProfile.role=='admin')">
            <a class="nav-link" >
            <i class="fas fa-users"></i>
            <span>Санал асуулга</span>
            </a>
      </router-link>
      <router-link to="/qaadmin" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='sts' || userProfile.role=='admin')">
            <a class="nav-link" >
            <i class="fas fa-users"></i>
            <span>Санал асуулга удирдах</span>
            </a>
      </router-link> -->
    <!-- Divider -->
    <hr class="sidebar-divider" />

    <!-- Heading -->
    <div
      class="sidebar-heading"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'student'
      "
    >
      Сурагч
    </div>
    <router-link
      to="/lessons"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'student'
      "
    >
      <a class="nav-link">
        <i class="fas fa-book"></i>
        <span>Xичээлүүд</span>
      </a>
    </router-link>
    <router-link
      to="/lessongridxdaalgavar"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'student'
      "
    >
      <a class="nav-link">
        <i class="fas fa-book"></i>
        <span>Даалгаварууд</span>
      </a>
    </router-link>
    <router-link
      to="/alllessonstudentscores"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'student'
      "
    >
      <a class="nav-link">
        <i class="fas fa-book"></i>
        <span>Миний дүн</span>
      </a>
    </router-link>
    <!-- Divider -->
    <hr
      class="sidebar-divider d-none d-md-block"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'student'
      "
    />
    <!-- Heading -->
    <div
      class="sidebar-heading"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'admin'
      "
    >
      ADMIN
    </div>

    <!-- <router-link to="/toberemovedlessons" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts')">
        <a class="nav-link" >
          <i class="fas fa-school"></i>
          <span>Xичээл xасаx xүсэлтүүд</span>
        </a>
      </router-link> -->

    <router-link
      to="/subschools"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'admin'
      "
    >
      <a class="nav-link">
        <i class="fas fa-school"></i>
        <span>Сургууль</span>
      </a>
    </router-link>

    <router-link
      to="/createschool"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'admin'
      "
    >
      <a class="nav-link">
        <i class="fas fa-school"></i>
        <span>Сургууль үүсгэx</span>
      </a>
    </router-link>

    <!-- <router-link
      to="/createnewsemester"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'admin'
      "
    >
      <a class="nav-link">
        <i class="fas fa-school"></i>
        <span>Шинэ семестр үүсгэx</span>
      </a>
    </router-link> -->

    <router-link
      to="/cities"
      class="nav-item"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'admin'
      "
    >
      <a class="nav-link">
        <i class="fas fa-school"></i>
        <span>Хот/Дүүрэг</span>
      </a>
    </router-link>

    <!-- <router-link to="/cities" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
        <a class="nav-link" >
          <i class="fas fa-school"></i>
          <span>Хот/Дүүрэг/Сургууль</span>
        </a>
      </router-link> -->

    <!-- Divider -->
    <!-- <hr class="sidebar-divider d-none d-md-block" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')"> -->

    <!-- Heading -->
    <!-- <div class="sidebar-heading" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
        Оюутан бүртгэл
      </div> -->

    <!-- Nav Item - Pages Collapse Menu -->

    <!-- <router-link to="/alllessons" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
            <a class="nav-link" >
            <i class="fas fa-star"></i>
            <span>Хичээлүүд</span>
            </a>
        </router-link> -->

    <!-- Divider -->
    <hr
      class="sidebar-divider d-none d-md-block"
      v-if="
        currentUser != null &&
        userProfile != null &&
        userProfile.role == 'admin'
      "
    />

    <!-- Sidebar Toggler (Sidebar) -->
    <div class="text-center d-none d-md-inline">
      <button
        class="rounded-circle border-0"
        id="sidebarToggle"
        @click="toggleSideBar"
      ></button>
    </div>
  </ul>
  <!-- End of Sidebar -->
</template>

<script>
import { mapState } from "vuex";
import mixin from "./global/mixin.js";
const fb = require("../firebaseConfig.js");

export default {
  name: "Navigation",
  mixins: [mixin],
  data() {
    return {
      appname: null,
      showlogo: null,
      logopath: null,
      schoolId: null,
      user: null,
      school: null,
    };
  },
  methods: {},
  computed: {
    ...mapState(["currentUser", "userProfile", "currentSchool"]),
  },
  created() {
    if (this.userProfile && this.userProfile.customer) {
      this.userProfile.customer.get().then(async (doc) => {
        let customer = doc.data();
        customer.id = doc.id;
        customer.ref = doc.ref;
        this.user = customer;
        this.schoolId = customer.school.id;
        customer.school.get().then((doc) => {
          let school = doc.data();
          school.id = doc.id;
          school.ref = doc.ref;
        });
      });
    }

    if (fb.APPNAME) this.appname = fb.APPNAME;
    if (fb.SHOWLOGO) this.showlogo = fb.SHOWLOGO;
    if (fb.LOGOPATH) this.logopath = fb.LOGOPATH;
  },
};
</script>